import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "../../../components/styled/Elements";
import { SignupWrapper } from "./styled";
import {
  AuthSlides,
  AuthSlidesAr,
} from "../../../helpers/authConstants/AuthConstants";
import AuthSlider from "../../../components/auth/authSlider/AuthSlider";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import SignupForm from "./components/SignupForm";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const SignUp = () => {
  const { i18n, t } = useTranslation();
  const landingUrl = process.env.REACT_APP_LANDING_URL;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const plan_type = queryParams.get("type");
  const status = queryParams.get("status");
  const navigate = useNavigate();

  const clearParams = () => {
    // Navigate to the same path without search params
    navigate(location.pathname, { replace: true });
  };

  const planObj = {
    plan_type: plan_type || null,
    plan_id: queryParams.get("plan_id"),
    duration: queryParams.get("duration"),
  };

  useEffect(() => {
    if (status) {
      if (status === "CAPTURED") {
        toast.success(t("payment_successful")); // you can customize this message
        clearParams();
      } else if (status === "DECLINED") {
        toast.error(t("payment_failed")); // you can customize this message
        clearParams();
      }
    }
  }, [status]);

  useEffect(() => {
    if (!planObj.plan_id) {
      window.location.href = landingUrl;
    }
    // if(!planObj.plan_id || !planObj.amount){
    //   window.location.href = landingUrl
    // }
  }, []);

  return (
    <SignupWrapper>
      <AuthHeader />
      <Box className="mt-4 container-fluid pb-4">
        <Row>
          <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 px-md-5 pb-4">
            <Box>
              <SignupForm planInfo={planObj} />
            </Box>
          </Col>
          <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 auth-slider">
            <Box className="sticky-item">
              <AuthSlider
                slides={i18n.language === "en" ? AuthSlides : AuthSlidesAr}
              />
            </Box>
          </Col>
        </Row>
      </Box>
    </SignupWrapper>
  );
};

export default SignUp;
